// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"841fa086","503":"a57134a7","705":"1edfab15","976":"014b6928"}[chunkId] + ".chunk.js";
};